import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@shared/config/routes';
import { SettingsNav } from '@widgets/settings-nav';
import { AccountSettingsPanel, SecuritySettingsPanel } from '@features/settings';

function SettingsLayout({
  subtitle,
  children,
}: {
  subtitle: string;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-2xl font-semibold">{t('settings.title')}</h1>
        <p className="text-sm opacity-70">{subtitle}</p>
      </header>
      <SettingsNav />
      {children}
    </div>
  );
}

export function SettingsAccountPage() {
  const { t } = useTranslation();
  return (
    <SettingsLayout subtitle={t('settings.subtitlesAccount')}>
      <AccountSettingsPanel />
    </SettingsLayout>
  );
}

export function SettingsSecurityPage() {
  const { t } = useTranslation();
  return (
    <SettingsLayout subtitle={t('settings.subtitleSecurity')}>
      <SecuritySettingsPanel />
    </SettingsLayout>
  );
}

export function SettingsIndexRedirect() {
  return <Navigate to={ROUTES.settingsAccount} replace />;
}
